function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { CallToAction, Label } from "../../atoms";
import ReactConfigContext from "../../ReactConfigContext";
export default function NavigationSidebar(param) {
    var label = param.label, items = param.items, activeIndex = param.activeIndex, action = param.action, style = param.style, className = param.className;
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    return /*#__PURE__*/ React.createElement("div", {
        style: style,
        className: twMerge("bg-bg-subtle rounded-xl p-7", className)
    }, !!label && /*#__PURE__*/ React.createElement(Label, {
        className: "opacity-50"
    }, label), /*#__PURE__*/ React.createElement("ul", {
        className: "mt-4 list-disc pl-5 grid grid-cols-1 grid-flow-row auto-rows-max gap-3 relative z-10"
    }, items.map(function(item, index) {
        return /*#__PURE__*/ React.createElement("li", {
            key: item.href
        }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, item), {
            className: twMerge("block", item.className)
        }), /*#__PURE__*/ React.createElement("span", {
            className: twMerge("text-navigation-base font-heading font-bold", activeIndex === index && "text-link-fg-base")
        }, item.label)));
    })), !!action && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: "border-b border-b-fg-base/20 my-6"
    }), /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, action), {
        className: twMerge("w-full", action.className)
    }))));
}

//# sourceMappingURL=NavigationSidebar.js.map